import React, { useEffect, useState } from 'react'
import styled from 'styled-components'

import SvgIcon from '../../components/SvgIcon'
import SortSvg from '../../public/static/images/icon-sorting.svg'
import { getColor, getFontSize } from '../../utils/cssUtils'

const SorterWrapper = styled.div`
  display: inline-flex;
  flex-flow: row nowrap;
`
const SorterIcon = styled(SvgIcon)`
  margin-right: 8px;
`
const SortItem = styled.div`
  line-height: 1;
  padding: 0 8px;
  border-right: 1px solid ${getColor('black')};
  &:first-of-type {
    padding-left: 0;
  }
  &:last-of-type {
    border: none;
    padding-right: 0;
  }
`
const HiddenInput = styled.input`
  appearance: none;
  opacity: 0;
  position: absolute;
`
const Label = styled.label`
  cursor: pointer;
  color: ${getColor('grey')};
  font-size: ${getFontSize('body2')};
  &:hover {
    color: ${getColor('pink')};
  }
  ${HiddenInput}:focus~&, ${HiddenInput}:focus:checked~& {
    color: ${getColor('pink')};
  }
  ${HiddenInput}:checked~& {
    color: ${getColor('theme')};
    &:hover {
      color: ${getColor('pink')};
    }
  }
`

const Sorter = ({ defaultSortBy, options, onSort }) => {
  const [selected, setSelected] = useState(defaultSortBy)

  const handleChange = e => {
    const targetValue = e.target.value
    setSelected(targetValue)
    onSort && onSort(targetValue)
  }

  useEffect(() => {
    setSelected(defaultSortBy)
  }, [defaultSortBy])

  return (
    <SorterWrapper>
      <SorterIcon svg={<SortSvg />} />
      {options.map(({ id, label }, index) => (
        <SortItem key={index}>
          <HiddenInput
            type='radio'
            id={id}
            name='sorter'
            checked={selected === id}
            value={id}
            onChange={handleChange}
          />
          <Label htmlFor={id}>{label}</Label>
        </SortItem>
      ))}
    </SorterWrapper>
  )
}

export default Sorter
